
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/artikel",
      function () {
        return require("private-next-pages/[locale]/artikel.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/artikel"])
      });
    }
  